import { RootState } from '../store';
import { SmppboxStateModel } from './smppboxStateModel';
import { createSelector } from '@reduxjs/toolkit';
import { initialSmppboxFetchingStatus } from './smppboxReducer';

const selectSmppboxState = (state: RootState): SmppboxStateModel => state.smppbox;
const selectServerId = (state: RootState, serverId: string): string => serverId;

const selectFetchingStateByServerId = createSelector(
  [selectSmppboxState, selectServerId],
  (state, serverId) => (
    state.fetchingStatus[serverId] || initialSmppboxFetchingStatus
  ),
);

export const selectIsLoadingSmppbox = createSelector(
  selectFetchingStateByServerId,
  state => state.loading,
);

export const selectErrorsForSmppbox = createSelector(
  selectFetchingStateByServerId,
  state => state.errors,
);

export const selectSmppboxByServerId = createSelector(
  [selectSmppboxState, selectServerId],
  (state, serverId) => state.entities[serverId],
);
